<template>
  <v-text-field
    variant="outlined"
    bg-color="white"
    density="compact"
    class="custom-input"
    v-bind="props"
    :model-value="toISO(modelValue)"
    @update:model-value="
      (event) => {
        if (isDateString(event)) {
          if (validateDate(fromISO(event))) $emit('update:model-value', fromISO(event));
        }
      }
    "
    :min="min && toISO(min)"
    :max="max && toISO(max)"
  ></v-text-field>
</template>

<script setup lang="ts">
import { isDateString } from "@/utils";
import dayjs from "dayjs";

const props = defineProps<{
  modelValue: Date;
  max?: Date;
  min?: Date;
  type: "datetime-local" | "date" | "time";
}>();
defineEmits<{ (event: "update:model-value", val: Date) }>();

const toISO = (date: Date) => {
  if (props.type == "datetime-local") {
    return dayjs(date).format(`YYYY-MM-DD[T]HH:mm`);
  }
  if (props.type == "date") {
    return dayjs(date).format(`YYYY-MM-DD`);
  }
  if (props.type == "time") {
    return dayjs(date).format(`HH:mm`);
  }
};

const fromISO = (str: string) => {
  if (props.type == "time") {
    const date = {
      hour: +str.split(":")[0],
      minute: +str.split(":")[1]
    };

    return dayjs(props.modelValue).set("hours", date.hour).set("minutes", date.minute).toDate();
  }
  if (props.type == "date") {
    const date = dayjs(str);
    return dayjs(props.modelValue)
      .set("year", date.year())
      .set("month", date.month())
      .set("date", date.date())
      .toDate();
  }
  return dayjs(str).toDate();
};

const fromISOBy = (str: string, refDate: Date) => {
  if (props.type == "time") {
    const date = {
      hour: +str.split(":")[0],
      minute: +str.split(":")[1]
    };

    return dayjs(refDate).set("hours", date.hour).set("minutes", date.minute);
  }
  if (props.type == "date") {
    const date = dayjs(str);
    return dayjs(refDate)
      .set("year", date.year())
      .set("month", date.month())
      .set("date", date.date())
      .toDate();
  }
  return dayjs(str);
};

const validateDate = (date: Date) => {
  if (props.max && fromISOBy(toISO(props.max)!, props.max) < fromISOBy(toISO(date)!, props.max)) {
    return false;
  }
  if (props.min && fromISOBy(toISO(props.min)!, props.min) > fromISOBy(toISO(date)!, props.min)) {
    return false;
  }
  return true;
};
</script>

<style lang="scss">
.v-text-field .v-field--no-label input, .v-text-field .v-field--active input {
 display: block;
}
</style>